import {
	Dialog,
	DialogActionsBar,
} from "@tql/ui-components-react/kendo/dialogs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import type { ComponentProps, ReactNode } from "react";

import styles from "./yes-no-dialog.module.css";

export type YesNoDialogProps = ComponentProps<typeof Dialog> & {
	open: boolean;
	title: string;
	message?: string;
	body?: ReactNode;
	yesText?: string;
	noText?: string;
	onYes: () => void;
	onNo: () => void;
	onClose?: () => void;
};

export function YesNoDialog({
	open,
	title,
	message,
	body,
	yesText = "Yes",
	noText = "No",
	onYes,
	onNo,
	onClose,
	...dialogProps
}: Readonly<YesNoDialogProps>) {
	if (!open) return null;

	return (
		<Dialog
			{...dialogProps}
			className={styles.container}
			onClose={onClose ?? onNo}
			title={title}
		>
			<div>{body ?? <p style={{ font: "inherit" }}>{message}</p>}</div>

			<DialogActionsBar>
				<Button onClick={onYes} variant={"danger"}>
					{yesText}
				</Button>
				<Button onClick={onNo} variant={"secondary"}>
					{noText}
				</Button>
			</DialogActionsBar>
		</Dialog>
	);
}
